import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useRecoilState } from "recoil";
import { AnimatePresence } from "framer-motion";
// import parseISO from "date-fns/parseISO";
// import differenceInSeconds from "date-fns/differenceInSeconds";
import clsx from "clsx";

import {
  getGroupForTitleEngage,
  getItemNumber,
  getGroupForTitle,
} from "../../helpers/text";
import {
  getSubheadingByGroupId,
  getNameByGroupId,
  getParentByGroupId,
  getGroupSubheadingInfo,
} from "../../helpers/arrays";
import { engageState } from "../../atoms/platform";
import { apiGetVideoInfo } from "../../lib/api/engage";

import { Tab } from "@headlessui/react";

import Loading from "../Shared/Loading";
import AgendaTopicInfoMobile from "../Engage/AgendaTopicInfoMobile";
import AgendaForPlayer from "../Engage/AgendaForPlayer";
import VideoShareButtons from "../Engage/VideoShareButtons";
import UserWayWidget from "../UserWayWidget";
import MuxLive from "../Video/MuxLive";

function PlayerLive() {
  const router = useRouter();
  const { client, id } = router.query;
  const [platform, setPlatform] = useRecoilState(engageState);
  const [agenda, setAgenda] = useState();
  const [active, setActive] = useState();
  const [mobileDetails, setMobileDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeVideo, setActiveVideo] = useState();
  const [playerVersion, setPlayerVersion] = useState("");

  useEffect(() => {
    async function fetchVideo() {
      setLoading(true);
      const result = await apiGetVideoInfo(id);
      if (result) {
        const { meeting, options } = result;
        const isCablecast = options.cablecastLiveUrl
          .toLowerCase()
          .includes("cablecast");
        if (isCablecast) {
          setPlayerVersion("cablecast");
        } else {
          setPlayerVersion("mux");
        }
        setPlatform(options);
        setAgenda(meeting);
        const compare = window.innerWidth;
        if (compare > 767) {
          setActiveVideo(1);
        } else {
          setActiveVideo(2);
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
    if (id) {
      fetchVideo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  function handleTopicChosen(topic) {
    setActive();
    setTimeout(() => {
      setActive(topic);
    }, 750);
  }

  function handleKeyDown(callback) {
    return (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        callback();
      }
    };
  }

  return (
    <div className="h-screen overflow-hidden bg-white">
      <div className="sr-only" aria-live="polite" aria-atomic="true">
        {active ? `Selected: ${active.name || active.title}` : ""}
      </div>
      {/* Desktop Header */}
      <div className="hidden bg-slate-900 py-2 xl:py-0 xl:h-16 w-full sm:flex justify-start items-center space-x-2 xl:space-x-6 px-2 2xl:px-12">
        <p className="text-xs md:text-sm lg:text-base xl:text-lg font-medium text-white mr-5">
          {platform?.clientName}
        </p>
        <h3 className="text-mini md:text-xs lg:text-sm xl:text-lg font-medium text-center text-white">
          {agenda?.meetingType}
        </h3>
        <p className="text-mini md:text-xs lg:text-sm xl:text-lg italic text-center text-zinc-200">
          {agenda?.scheduleString}
        </p>
      </div>
      {/* Desktop */}
      <div className="hidden sm:grid sm:grid-cols-4 md:grid-cols-12 h-full overflow-hidden">
        {/* Main Area */}
        <div className="sm:col-span-2 md:col-span-6 lg:col-span-6 2xl:col-span-6 overflow-y-auto bg-slate-900">
          {/* Video Player */}

          {/* <div className="relative w-full h-[50%]"> */}
          <div className="sticky top-0 z-50 w-full h-[50%]">
            <div className="aspect-w-16 aspect-h-9">
              {playerVersion === "cablecast" ? (
                <iframe
                  className="trms-player absolute inset-0 w-full h-full"
                  type="text/html"
                  width="360"
                  height="240"
                  src={platform?.cablecastLiveUrl}
                  webkitAllowFullScreen
                  mozallowfullscreen
                  allowFullScreen
                ></iframe>
              ) : (
                <MuxLive
                  // placeholderUrl="https://cdn.sanity.io/images/4jvom4yf/production/1748bfcd54b11c5a5374c935676f77b8e9adbd0d-1400x780.png"
                  agenda={agenda}
                  playbackId={platform?.cablecastLiveUrl}
                  platform={platform}
                />
              )}
            </div>
          </div>
          {/* Selection Options */}
          <div className="bg-slate-900 h-full w-full">
            <Tab.Group>
              <Tab.List className="flex px-2 2xl:px-6">
                <Tab
                  className={({ selected }) =>
                    clsx(
                      "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-medium text-blueGray-200 rounded-t-md",
                      "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900",
                      selected
                        ? "bg-coolGray-700"
                        : "hover:bg-white/[0.12] hover:text-white border border-coolGray-700",
                    )
                  }
                >
                  Table of Contents
                </Tab>
                <Tab
                  className={({ selected }) =>
                    clsx(
                      "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-medium text-blueGray-200 rounded-t-md",
                      "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900",
                      selected
                        ? "bg-coolGray-700"
                        : "hover:bg-white/[0.12] hover:text-white border border-coolGray-700",
                    )
                  }
                >
                  Share
                </Tab>
                {/* <Tab
                  className={({ selected }) =>
                    clsx(
                      "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-medium text-blueGray-200 rounded-t-md",
                    "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900",
                      selected
                        ? "bg-coolGray-700"
                        : "hover:bg-white/[0.12] hover:text-white border border-coolGray-700"
                    )
                  }
                >
                  Transcript
                </Tab> */}
              </Tab.List>
              <Tab.Panels>
                <Tab.Panel aria-label="Table of Contents">
                  <div className="overflow-y-auto bg-slate-900 pb-sm">
                    <div className="relative mx-2 2xl:mx-6">
                      {/* Content */}
                      <div className="flex flex-col">
                        {!agenda?.archiveVideo ? (
                          <>
                            <div className="space-y-1 overflow-y-auto">
                              {agenda?.groupOrder.map((group, gIdx) => {
                                // todo figure out if the group has elapsed seconds
                                const name = getNameByGroupId(
                                  group._id,
                                  agenda?.groupSubheadings,
                                  group.name,
                                );
                                const groupInfo = getGroupSubheadingInfo(
                                  group._id,
                                  agenda?.groupSubheadings,
                                );
                                const groupActions = agenda?.topics
                                  .map((topic) => {
                                    if (
                                      topic.agendaGroup._id.toString() ===
                                      group._id.toString()
                                    ) {
                                      if (!topic.bulkTopic) {
                                        return topic;
                                      } else {
                                        return null;
                                      }
                                    }
                                    return null;
                                  })
                                  .filter((topic) => topic !== null);
                                groupActions.sort((a, b) => a.order - b.order);

                                return (
                                  <section
                                    key={`group-${gIdx}`}
                                    aria-label={name}
                                  >
                                    <div
                                      className={clsx(
                                        "mt-2 pl-1.5 pt-1.5 rounded-md",
                                      )}
                                    >
                                      <p
                                        className={clsx(
                                          "text-zinc-300",
                                          "text-sm 2xl:text-base inline-flex items-center select-none",
                                        )}
                                      >
                                        {getGroupForTitleEngage(
                                          agenda?.groupNumbering,
                                          gIdx,
                                          agenda?.groupOrder,
                                          agenda?.childNumbering,
                                        )}
                                        {name}
                                      </p>
                                    </div>
                                    {groupActions.length > 0 && (
                                      <ul role="list">
                                        {groupActions.map((topic, tIdx) => (
                                          <li key={topic._id}>
                                            <button
                                              type="button"
                                              aria-current={
                                                active?._id === topic._id
                                                  ? "true"
                                                  : undefined
                                              }
                                              onClick={() =>
                                                handleTopicChosen(topic)
                                              }
                                              className="w-full text-left py-2 2xl:py-3 hover:bg-zinc-600 focus-visible:bg-zinc-600 transform duration-200 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
                                            >
                                              <span
                                                className={clsx(
                                                  active?._id === topic._id
                                                    ? "text-white font-semibold underline"
                                                    : "text-zinc-200",
                                                  "ml-2 lg:ml-4 text-sm 2xl:text-base font-medium cursor-pointer transition duration-200 2xl:text-justify inline-flex items-center",
                                                )}
                                              >
                                                {getGroupForTitle(
                                                  agenda?.groupNumbering,
                                                  gIdx,
                                                  agenda?.groupOrder,
                                                  agenda?.childNumbering,
                                                )}
                                                {getItemNumber(
                                                  agenda?.topics,
                                                  agenda?.itemNumbering,
                                                  topic,
                                                  tIdx,
                                                  agenda?.groupNumbering,
                                                  agenda?.childNumbering,
                                                )}
                                              </span>
                                            </button>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </section>
                                );
                              })}
                            </div>
                            {loading && <Loading />}
                          </>
                        ) : (
                          <p
                            role="status"
                            className="text-white 2xl:text-xl font-medium text-center mt-8"
                          >
                            No Chapters Available
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </Tab.Panel>
                <Tab.Panel aria-label="Share options">
                  <div className="min-h-96 overflow-y-auto mx-2 2xl:mx-6">
                    <VideoShareButtons />
                  </div>
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>
        {/* SideBar */}
        <div className="hidden sm:block sm:col-span-2 md:col-span-6 lg:col-span-6 2xl:col-span-6 px-2 border-l border-slate-600 overflow-y-auto h-full">
          <AgendaForPlayer agenda={id} client={client} activeTopic={active} />
        </div>
      </div>
      {/* Mobile */}
      <div className="sm:hidden flex flex-col h-full overflow-y-auto">
        {/* Video Player */}
        <div className="absolute top-0 left-0 w-full h-[14rem] z-20">
          <div className="aspect-w-16 aspect-h-9">
            {playerVersion === "cablecast" ? (
              <iframe
                title="Live video stream"
                className="trms-player absolute inset-0 w-full h-full"
                type="text/html"
                width="360"
                height="240"
                src={platform?.cablecastLiveUrl}
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
              ></iframe>
            ) : (
              <MuxLive
                // placeholderUrl="https://cdn.sanity.io/images/4jvom4yf/production/1748bfcd54b11c5a5374c935676f77b8e9adbd0d-1400x780.png"
                agenda={agenda}
                playbackId={platform?.cablecastLiveUrl}
                platform={platform}
              />
            )}
          </div>
        </div>
        {/* Mobile Heading */}
        <p className="text-sm md:text-base text-center font-medium text-black px-4 mt-[15rem]">
          {platform?.clientName}
        </p>
        <p className="text-xs md:text-sm text-center font-medium text-black px-4">
          {agenda?.department?.name}
        </p>
        <p className="text-xs md:text-sm text-center italic text-black px-4">
          {agenda?.scheduleString}
        </p>
        {/* Agenda  */}
        <div className="mt-4">
          {agenda?.groupOrder.map((group, index) => {
            const subheading = getSubheadingByGroupId(
              group.id,
              agenda.groupSubheadings,
            );
            const parentGroup = getParentByGroupId(
              group.id,
              agenda?.groupSubheadings,
            );
            const name = getNameByGroupId(
              group.id,
              agenda.groupSubheadings,
              group.name,
            );
            const groupActions = agenda?.topics
              .map((topic) => {
                if (topic.agendaGroup._id.toString() === group._id.toString()) {
                  if (!topic.bulkTopic) {
                    return topic;
                  } else {
                    return null;
                  }
                }
                return null;
              })
              .filter((topic) => topic !== null);
            groupActions.sort((a, b) => a.order - b.order);
            return (
              <div
                key={index}
                className={clsx(group?.parentGroup && "ml-2", "mb-4")}
              >
                <div className="border-b border-gray-800">
                  <p className="px-2 text-sm text-black font-semibold">
                    {getGroupForTitleEngage(
                      agenda?.groupNumbering,
                      index,
                      agenda?.groupOrder,
                      agenda?.childNumbering,
                    )}
                    {name}
                  </p>
                </div>
                <p className="px-2 text-xs text-black italic pt-1 ml-2 whitespace-pre-line text-justify">
                  {subheading}
                </p>
                <ul role="list">
                  {groupActions.map((topic, i) => (
                    <li key={topic.id}>
                      <button
                        type="button"
                        aria-current={
                          active?.id === topic.id ? "true" : undefined
                        }
                        disabled={!topic.hasDetails}
                        onClick={() => {
                          if (topic.hasDetails) {
                            handleTopicChosen(topic);
                            setMobileDetails(true);
                          }
                        }}
                        className={clsx(
                          i === 0 ? "mt-1" : "",
                          active?.id === topic.id
                            ? "text-amber-800 font-bold scale-105"
                            : topic.hasDetails
                              ? "text-blue-700 hover:text-blue-400"
                              : "text-gray-700",
                          "ml-4 mb-1 transform duration-200 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-400 rounded",
                        )}
                      >
                        <span className="inline-flex text-xs font-medium">
                          {getGroupForTitle(
                            agenda?.groupNumbering,
                            index,
                            agenda?.groupOrder,
                            agenda?.childNumbering,
                          )}
                          {getItemNumber(
                            agenda?.topics,
                            agenda?.itemNumbering,
                            topic,
                            i,
                            agenda?.groupNumbering,
                            agenda?.childNumbering,
                          )}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <AnimatePresence>
          {mobileDetails && (
            <AgendaTopicInfoMobile
              visible={setMobileDetails}
              topic={active?.id}
              enablePri={platform?.enablePriorities}
              client={client}
            />
          )}
        </AnimatePresence>
        <div role="status" aria-live="polite">
          {loading && <Loading />}
        </div>
      </div>
      <UserWayWidget />
    </div>
  );
}

export default PlayerLive;
